import { createContext, useContext } from 'react'

import { Theme } from '@/hooks/useTheme'

export const ThemeContext = createContext<{
  isDarkMode: boolean
  isLightMode: boolean
  onThemeChange: (theme: Theme) => void
  themeLocalStorageValue: Theme
  currentTheme: Theme.dark | Theme.light
}>(undefined)
ThemeContext.displayName = 'ThemeContext'

export const useThemeContext = () => useContext(ThemeContext)
